import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { environment } from '../../../environments/environment';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { getStorage, provideStorage } from '@angular/fire/storage';
import { getFunctions, provideFunctions } from '@angular/fire/functions';
import { getMessaging, provideMessaging } from '@angular/fire/messaging';
import { provideAnalytics, getAnalytics } from '@angular/fire/analytics';

@NgModule({
    imports: [
        SharedModule,
    ],
    providers: [
        provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
        provideAuth(() => getAuth()),
        provideFirestore(() => {
            // ENABLE THIS FOR FIRESTORE RULE DEBUGGING
            // setLogLevel("debug");
            return getFirestore();
        }),
        provideStorage(() => getStorage()),
        provideFunctions(() => {
            const functions  = getFunctions()
            functions.region = 'us-central1';
            return functions;
        }),
        provideMessaging(() => getMessaging()),
        provideAnalytics(() => getAnalytics()),
    ],
})
export class SoPoFirebaseModule {
    constructor() {}
}